// extracted by mini-css-extract-plugin
export default {"innerWrapper":"zy-z","tooltipWrapper":"Ay-z","icon":"By-z","tooltip":"Cy-z","content":"Dy-z"};